import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter,
  OnChanges
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EmailService } from '../email.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { IEmail } from '../../../models/email';
import { ISession } from '../../../models/session';
import { union, path } from 'ramda/es';
import { TagsFormatService } from '../../tags/tags-format.service';
import { ValidateImportService, IValidateResults } from './validate.import.service';
import loader from './editor.loader';

@Component({
  templateUrl: './editor.component.html',
  selector: 'email-editor',
  styleUrls: ['../email.component.scss']
})
export class EmailEditorComponent implements OnInit, OnChanges {
  @ViewChild('testMailModal') testMailModal: any;
  @ViewChild('object') object: any;
  @ViewChild('confirmImport') confirmImportModal: TemplateRef<any>;

  @Input('can-send') canSend = true;
  @Input('session') session: ISession;
  @Input() completions = [];

  @Input('email')
  email: IEmail = {
    type: '',
    language: '',
    subject: '',
    fromName: '',
    content: '',
    schedule: '',
    hasSchedule: false,
    hasMailingList: false
  };
  public types = ['confirmations', 'alerts', 'invitations', 'accounts'];
  public times = [1, 6, 10, 12, 24];

  public saved = true;
  public modalRef: BsModalRef;
  public testAddress = '';
  public mailingAddress = '';
  public mailingList: Array<string> = [];
  public loadingElement: 'mailing' | 'preview' | '' = '';
  private validateResults: IValidateResults = { validEmails: [], rejectedEmails: [] };

  @Output() onSave = new EventEmitter<{ email: IEmail; mailingList: Array<string> }>();
  @Output() onSendMail = new EventEmitter<boolean>();
  @Output() onSendTestMail = new EventEmitter<string>();

  constructor(
    private translateService: TranslateService,
    private modalService: BsModalService,
    private emailService: EmailService,
    private tagFormatService: TagsFormatService,
    private validateImportService: ValidateImportService
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.translateService
      .get('sessions.details.emails.warning_import')
      .subscribe(warningImportText => {
        $('.wrapper-content').tooltip({
          title: warningImportText,
          placement: 'top',
          selector: '.import-emails'
        });
      });
  }

  ngOnChanges(changes: any) {
    const email = path(['email', 'currentValue'], changes);
    if (email && email.type) {
      // make sure we have actual mailing list
      this.emailService.getMailingList(this.session, this.email.type)
      .subscribe(list => {
        this.mailingList = list;
      })
    }
  }

  save() {
    this.onSave.emit({ email: this.email, mailingList: this.mailingList });
    this.saved = true;
  }
  sendMail() {
    this.onSendMail.emit(true);
  }
  sendTestMail() {
    this.onSendTestMail.emit(this.testAddress);
    this.modalRef.hide();
  }

  getImport($ev) {
    const file: File = $ev.target.files[0];
    if (file.type !== 'text/csv' && file.type !== 'application/vnd.ms-excel') {
      return toastr.error(
        this.translateService.instant('sessions.details.emails.error_import_type')
      );
    }
    const fd: FileReader = new FileReader();
    fd.onloadend = () => {
      this.validateResults = this.validateImportService.validate(String(fd.result))
      return this.modalRef = this.modalService.show(this.confirmImportModal, Object.assign({}, { class: 'inmodal' }));
    };
    fd.readAsText(file);
  }

  importValidEmails(validEmails: Array<string>) {
    this.mailingList = validEmails;
  }

  showMailingList(template: TemplateRef<any>) {
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.loadingElement = 'mailing';
    this.openModal(template);
    if (!this.session) {
      this.loadingElement = '';
      return this.mailingList;
    }
    this.emailService.getMailingList(this.session, this.email.type).subscribe(
      list => {
        this.mailingList = union(this.mailingList, list);
        this.loadingElement = '';
      },
      err => {
        toastr.error(this.translateService.instant('action.failed'));
        this.loadingElement = '';
      }
    );
  }

  showConfirmMail(template: TemplateRef<any>) {
    this.modalRef.hide();
    this.openModal(template);
  }

  showConfirmImport(template: TemplateRef<any>) {
    this.modalRef.hide();
    this.openModal(template);
  }

  removeEmailAddress(email: string) {
    this.mailingList.splice(this.mailingList.indexOf(email), 1);
  }

  addEmailAddress() {
    this.mailingList.push(this.mailingAddress);
    this.mailingAddress = '';
    this.saved = false;
  }

  clearMailingList() {
    this.modalRef.hide();
    this.mailingList = [];
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'inmodal' }));
  }

  showPreview() {
    this.loadingElement = 'preview';
    const preview = open('url', this.email.subject, 'height=650,width=700');
    preview.document.write(loader);
    this.emailService.retrieveMailPreview(this.session, this.email.type).subscribe(
      ({ content }) => {
        preview.document.body.innerHTML = '';
        preview.document.write(content);
        this.loadingElement = '';
      },
      err => {
        toastr.error(this.translateService.instant('action.failed'));
        this.loadingElement = '';
        preview.close();
      }
    );
    return preview;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/email/editor/editor.component.ts